import { render, staticRenderFns } from "./SmsRecord.vue?vue&type=template&id=45202c02&"
import script from "./SmsRecord.vue?vue&type=script&lang=js&"
export * from "./SmsRecord.vue?vue&type=script&lang=js&"
import style0 from "./SmsRecord.vue?vue&type=style&index=0&id=45202c02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports